import Plugin from 'src/plugin-system/plugin.class';

export default class BackToTopPlugin extends Plugin {

    init() {
        this._registerEvents();
        this._registerScroll();
    }

    _registerEvents() {
        $( window ).on('scroll', () => {
            this._registerScroll();
        });

        $(this.el).on('click', function() {
            window.scrollTo(0, 0);
        });
    }

    _registerScroll() {

        var winTop = $(window).scrollTop(), 
            docHeight = $(document).height(), 
            winHeight = $(window).height();

        var progress = winTop/(docHeight-winHeight);
        var strokeDashArray = $(this.el).find('rect').css('stroke-dasharray');

        if (winTop > 200) {
            $(this.el).addClass('is--visible');
        } else {
            $(this.el).removeClass('is--visible');
        }

        $(this.el).find('rect').css('stroke-dashoffset', (1-progress)*parseFloat(strokeDashArray));

    }

}